import React, { useState } from 'react';
import BMIMeasurementItemHintModal from './BMIMeasurementItemHintModal';

const BMIMeasurementItemHint: React.FC = () => {
	const [isHintOpen, setIsHintOpen] = useState(false);
	return (
		<>
			<div
				style={{ marginLeft: '-20px', cursor: 'pointer' }}
				onClick={() => setIsHintOpen(true)}
			>
				<img
					src='/dist/icons/info-gray.svg'
					alt='BMI Measurement Hint'
					width='16px'
				/>
			</div>
			{isHintOpen && (
				<BMIMeasurementItemHintModal
					isOpen
					onClose={() => setIsHintOpen(false)}
				/>
			)}
		</>
	);
};

export default BMIMeasurementItemHint;
